module.exports = __webpack_public_path__ + "img/kaya_bg.fbdfb3e0.png";